module.exports = __webpack_public_path__ + "assets/react.d0391bda.svg";